import React from "react";
import { FC, useContext } from "react";
import ThemeContext from "../themes/context";

export interface IconProps {
	color?: string;
	size?: number;
}

export interface IconPackageProps {
	color?: string;
	size?: number;
	icon?: string;
}

export const InfoIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "InfoIcon", color, size }), {
		color,
		size,
	});
};

export const SearchIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "SearchIcon", color, size }), {
		color,
		size,
	});
};

export const InfoRotateLeft: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "InfoRotateLeft", color, size }), { color, size });
};

export const InfoRotateRight: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "InfoRotateRight", color, size }), { color, size });
};

export const ExclamationIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "ExclamationIcon", color, size }), { color, size });
};

export const StethoscopeIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "StethoscopeIcon", color, size }), { color, size });
};

export const StretcherIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "StretcherIcon", color, size }), {
		color,
		size,
	});
};

export const AlterIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "AlterIcon", color, size }), {
		color,
		size,
	});
};

export const BrainIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "BrainIcon", color, size }), {
		color,
		size,
	});
};

export const CancelIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "CancelIcon", color, size }), {
		color,
		size,
	});
};

export const PlayIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "PlayIcon", color, size }), {
		color,
		size,
	});
};

export const MobileMedicalHelp: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "MobileMedicalHelp", color, size }), {
		color,
		size,
	});
};

export const RescheduleIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "RescheduleIcon", color, size }), { color, size });
};

export const DownloadIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "DownloadIcon", color, size }), { color, size });
};

export const CheckIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "CheckIcon", color, size }), {
		color,
		size,
	});
};

export const StarIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "StarIcon", color, size }), {
		color,
		size,
	});
};

export const MastercardIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "MastercardIcon", color, size }), { color, size });
};

export const CheckboxIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "CheckboxIcon", color, size }), { color, size });
};

export const FilterIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "FilterIcon", color, size }), {
		color,
		size,
	});
};

export const CipherIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "CipherIcon", color, size }), {
		color,
		size,
	});
};

export const ScheduleIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "ScheduleIcon", color, size }), {
		color,
		size,
	});
};

export const ArrowLeftIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "ArrowLeftIcon", color, size }), { color, size });
};

export const ArrowRightIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "ArrowRightIcon", color, size }), { color, size });
};

export const CalanedarCheckIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "CalanedarCheckIcon", color, size }), { color, size });
};

export const CrossedBellIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "CrossedBellIcon", color, size }), { color, size });
};

export const WifiIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "WifiIcon", color, size }), {
		color,
		size,
	});
};

export const HeadPhoneIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "HeadPhoneIcon", color, size }), { color, size });
};

export const ClockForwardIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "ClockForwardIcon", color, size }), { color, size });
};

export const VitatCalendarIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "VitatCalendarIcon", color, size }), { color, size });
};

export const DoubleArrowRightIcon: FC<IconProps> = ({ color, size }) => {
	const theme = useContext(ThemeContext);
	return React.cloneElement(theme.icons({ icon: "DoubleArrowRightIcon", color, size }), { color, size });
};
